
import { Component, Vue, Prop } from 'vue-property-decorator'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import { UserModule } from '@/store/modules/user'
import HsPlupload from '@/components/plupload/main.vue'
import setting from '@/settings'
import util from '@/utils/busi/util'
import dayjs from 'dayjs'

@Component({
  name: 'Base',
  components: {
    DictSelect,
    HsPlupload
  }
})

export default class Base extends Vue {
  @Prop({ type: String })
  private flag!: string

  private dayjs = dayjs

  private setting = setting
  get isEdit () {
    return this.flag !== 'show'
  }

  private filters = {
    mime_types: [
      { title: 'image type', extensions: 'bmp,jpg,png,jpeg,gif,gpng,ico' }
    ]
  }

  get token () {
    return UserModule.token
  }

  private picList: any[] = []

  private up: any = {}

  private files: any[] = []

  private introduction = ''

  private form = {}

  private serverConfigUrl = ''

  private validate (callback: Function) {
    (this.$refs.form as any).validate(() => {
      this.hidden = !this.data.logo
      callback()
    })
  }

  get schoolId () {
    return util.getRouterParams().schoolId
  }

  @Prop({ type: Object })
  private data!: {}|any

  private rules = this.data.flag !== 'show' ? {
    title: [
      { required: true, message: '请输入简章标题', trigger: 'blur' }
    ],
    goal: [
      { required: true, message: '请输入招生对象', trigger: 'blur' }
    ],
    state: [
      { required: true, message: '请选择状态', trigger: 'change' }
    ],
    labels: [
      { required: true, message: '请选择标签', trigger: 'blur' }
    ],
    hotSubjects: [
      { required: true, message: '请选择热门专业', trigger: 'blur' }
    ],
    degrees: [
      { required: true, message: '请选择开设层次', trigger: 'blur' }
    ],
    content: [
      { required: true, message: '请输入院校简介', trigger: 'blur' }
    ],
    peopleNum: [
      { required: true, validator: this.checkPeopleNum, trigger: 'change' }
    ],
    forecast: [
      { required: true, message: '请选择状态', trigger: 'change' }
    ],
    entrance: [
      { required: true, message: '请选择状态', trigger: 'change' }
    ],
    endTime: [
      { required: true, message: '请选择结束时间', trigger: 'change' }
    ]
  } : {}

  private hidden = !1

  private checkPeopleNum (rule: any, value: any, callback: any) {
    if (!value) {
      return callback(new Error('招生人数不能为空'))
    }
    setTimeout(() => {
      if (!Number.isInteger(value)) {
        callback(new Error('请输入数字值'))
      } else {
        if (value >= 1000000) {
          callback(new Error('招生人数最大为999999'))
        } else {
          callback()
        }
      }
    }, 1000)
  }

  private degreeChange (val: any, labels: any) {
    this.data.degreeName = labels.join(',');
    (this.$refs.form as any).validate()
  }

  private labelChange (val: any, labels: any) {
    this.data.labelName = labels.join(',');
    (this.$refs.form as any).validate()
  }

  private subChange (val: any, labels: any) {
    this.data.hotSubjectName = labels.join(',');
    (this.$refs.form as any).validate()
  }

  private inputUploader (up: any) {
    this.up = up
    this.files = up.files
  }

  private filesAdded (up: any, files: any) {
    if (files.length > 1) {
      this.$message.error('每次只允许选择一张图片')
      return
    }
    if (up.files.length > 1) {
      up.removeFile(up.files[0])
    }
    this.upload()
  }

  private async upload () {
    console.log(this.up)
    this.up.start()
  }

  private UploadComplete (up: any, files: any) {
    console.log(up, files)
  }

  private FileUploaded (up: any, files: any, res: any) {
    const response = JSON.parse(res.response)
    this.files[0].name = response.fileInfos[0].originalFileName
    this.files[0].path = response.fileInfos[0].savePath
    this.hidden = !1
    this.data.logo = response.fileInfos[0].savePath
  }

  private delImg () {
    this.data.logo = ''
  }

  private error (up: any, res: any) {
    if (res.code === -601) {
      this.$message.error('只能上传bmp,jpg,png,jpeg,gif,gpng,ico等图片格式')
      return
    }
    this.$message.error(res.message)
  }
}
